module.exports = __webpack_public_path__ + "static/img/20.9d927f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/20.jpg
// module id = NcpM
// module chunks = 1